import axios from 'axios';

export const getFirstAxiosError = (error: unknown, defaultMessage?: string): string => {
    if (axios.isAxiosError(error)) {
        const data = error.response?.data;

        const firstError = Object.values(data as object)[0];

        return firstError[0];
    }

    return defaultMessage ?? 'Unknown error';
};
